export default import.meta.ROLLUP_FILE_URL_yqw1ioHhKg4Er_L0tnFKFg